// extracted by mini-css-extract-plugin
module.exports = {"TablePagination":"style_TablePagination__2tsfC","button":"style_button__Pzc6-"};